import { Search } from './search';

export class GlobalSearch extends Search<GlobalSearch> {
  search: string;
}
